"use strict";
/**
 * City factory
 * formats the raw data into a usable format
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const LANG_1 = __importDefault(require("../../../constants/lang/LANG"));
/**
 * Returns formatted city info
 * @param {CityType} city
 * @param {string} language
 * @returns {CityFactoryType}
 */
function cityFactory(city, language = LANG_1.default.EN) {
    return {
        id: (0, get_1.default)(city, 'id', 0),
        name: (0, get_1.default)(city, `name.${language}`, ''),
        code: (0, get_1.default)(city, 'code', ''),
        branchCount: (0, get_1.default)(city, 'branchCount', 0),
        regionName: (0, get_1.default)(city, `region.name.${language}`, ''),
        regionId: (0, get_1.default)(city, 'region.id', 0),
    };
}
exports.default = cityFactory;
